// @flow
import omitEmptyFields from 'mz-utils/omitEmptyFields'
import client from '../../client'

// Types
import type { SuggestionLocation } from '../../models/location'

export type Options = {
  radius: string,
  strictbounds: string,
  include_ports: boolean,
  include_far: boolean,
}

// API Endpoint
export const LOCATIONS_ENDPOINT = '/locations/query/'

/**
 * Get place suggestions from a potencially partial user input.
 * @param  {string} value A string to get suggestions from.
 * @param  {Object} biasCoordinates An object with `lat` and `lng` keys to bias
 *                                  the suggestions by giving priority to places
 *                                  closer to the provided coordinates.
 * @return {Promise|Error} A Promise eventually resolving to the suggestions
 */
const getSuggestions = (
  value: string,
  biasCoordinates?: SuggestionLocation,
  otherParams?: Options
): Promise<Array<SuggestionLocation>> => {
  if (!value) {
    return Promise.reject(new Error('Query not provided'))
  }

  const params = omitEmptyFields(
    {
      query: value,
      include_train_stations: true,
      include_ports: true,
      include_far: false,
      ...biasCoordinates,
      ...otherParams,
    },
    { string: true, number: true }
  )

  return client.get(LOCATIONS_ENDPOINT, { query: params }).then((response) => {
    // show favourite locations first
    const sortedResults = response.results.slice().sort((a, b) => {
      if (!a.favorite_id && b.favorite_id) return 1
      if (a.favorite_id && !b.favorite_id) return -1
      return 0
    })
    return sortedResults
  })
}

export default getSuggestions
